import { useContext } from "react";
import { AppContext } from "../App";
import { t } from "../i18n";

export const Loader = () => {
	const { isTransitioning } = useContext(AppContext);

	return (
		<div
			className={
				"loader-container kensei_03" +
				(isTransitioning ? " fade-in" : "")
			}
		>
			<div className="spinner"></div>
			<p className="loader-text">
				{t("Te estamos redireccionando a tu Área de Clientes MAPFRE")}
			</p>
		</div>
	);
};
